<template>
    <transition name="refresh" mode="out-in">
        <slot :key="useSpotRatesStore().datetime"/>
    </transition>
</template>
